import React, { Suspense, useState, createRef, useEffect } from "react"
import { Routes, Route, useLocation } from "react-router-dom"
import { ConfigProvider, Layout } from "antd"
import { useSnapshot } from "valtio"
import routeConfig from "./config/routerConfig"
import zhCN from "antd/locale/zh_CN"
import generalStore from "@/store/general"
import styles from "./App.modules.less"

// import Header from "@/components/header"
// import Home from "@/views/home/home"
// import SongSheetDetail from "@/views/songDetail/songSheetDetail"

import Slider from "@/components/slider"
import HeaderCom from "@/components/header"
import FooterCom from "@/components/footer/footer"
import AddSongSheet from "@/components/addSongSheet"
import Visual from "@/components/visual"
import Person from "@/components/person/person"

const { Header, Footer } = Layout
const siderStyle = {
  width: "200px",
  backgroundColor: "#e1f1f1",
  borderRight: "1px solid var(--color)"
}
const layoutStyle = {
  width: "calc(100% - 200px)"
}
const headerStyle = {
  textAlign: "center",
  color: "#fff",
  height: 60,
  // paddingInline: 50,
  // lineHeight: "64px",
  backgroundColor: "var(--color)"
}
const contentStyle = {
  minWidth: 500,
  height: "calc(100vh - 140px)",
  backgroundColor: "white",
  padding: "20px",
  overflow: "scroll"
}
const footerStyle = {
  position: "relative",
  height: "80px"
}
const backTopStyle = {
  position: "fixed",
  right: "30px",
  bottom: "100px",
  zIndex: 2,
  background: "var(--color)",
  borderRadius: "50%",
  color: "white",
  padding: "7px 12px",
  cursor: "pointer",
  display: "none"
}

const App = () => {
  const { personFlag } = useSnapshot(generalStore)
  const [throttle, setThrottle] = useState(false)
  const backRef = createRef()
  useEffect(() => {
    // 手动设置root的宽度为100%
    const root = document.querySelector("#root")
    root.style.width = "100%"
  }, [])

  // 判断是否到底部
  const handleScroll = (e) => {
    // console.log(e)
    let el = e.target
    // 设置超出100显示返回顶部
    if (el.scrollTop > 100) {
      backRef.current.style.display = "block"
    } else {
      backRef.current.style.display = "none"
    }

    //判断是否到达div容器底部
    if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
      //控制页数
      // console.log("底部")
      if (throttle) return
      generalStore.toScrollBot = true
      setThrottle(true)
      setTimeout(() => {
        setThrottle(false)
      }, 1000)
    } else {
      generalStore.toScrollBot = false
    }
  }
  // 返回顶部（未做多次点击的节流）
  const backTop = () => {
    let dom = document.getElementsByClassName("content")[0]
    const timer = setInterval(() => {
      let top = dom.scrollTop
      if (top > 0) {
        dom.scrollTop = top - 50
      } else {
        clearInterval(timer)
      }
    }, 10)
  }
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#269A99"
        }
      }}
    >
      <>
        <div className={styles.App}>
          {/* <Layout> */}
          <div style={siderStyle}>
            <Slider></Slider>
          </div>
          <div style={layoutStyle}>
            <Header style={headerStyle}>
              <HeaderCom></HeaderCom>
            </Header>
            <div
              style={contentStyle}
              className="scrollX scrollY content"
              onScroll={(e) => handleScroll(e)}
            >
              {/* 此处没有用ant的FloatButton.BackTop，是因为有bug显示不出来 */}
              <div style={backTopStyle} onClick={backTop} ref={backRef}>
                <i className="iconfont">&#xe666;</i>
              </div>
              <Suspense>
                <Routes>
                  {routeConfig.map((item) => (
                    <Route
                      path={item.path}
                      element={item.component}
                      key={item.name}
                    >
                      {item.meta.title}
                    </Route>
                  ))}
                  <Route path="/" element={routeConfig[0].component} />
                </Routes>
              </Suspense>
            </div>
            <Footer style={footerStyle}>
              <FooterCom></FooterCom>
            </Footer>
          </div>
          <AddSongSheet></AddSongSheet>
          <Visual></Visual>
          {personFlag && <Person></Person>}
        </div>
      </>
    </ConfigProvider>
  )
}

export default App
